import React from "react";

import Icon from "@components/atoms/Icon";

import type { OrderStatusText, StatusColor } from "@const/enum";
import { IconName } from "@const/enum";

interface IProps {
  statusName: string;
  statusColor: StatusColor | "";
  orderName?: string;
  children?: React.ReactNode;
}

function Status({ statusName, statusColor, orderName, children }: IProps) {
  return (
    <div className="flex items-center">
      <Icon className={statusColor} name={IconName.Default_700} />
      <div className="flex items-start gap-1">
        {children ?? (
          <>
            {Boolean(orderName) && (
              <>
                <span className="grow-0">{orderName}</span>
                <span className="grow-0">-</span>
              </>
            )}
            <span className="grow-0">{statusName}</span>
          </>
        )}
      </div>
    </div>
  );
}

export default Status;
